import clsx from 'clsx';
import { DIVIDE_STATUS_ITEMS } from '../constants';
import useFetchCandidateBoards from '../api/useFetchCandidateBoards';
import useUpdateCandidateBoard from '../api/useUpdateCandidatesBoard';
import type { Color } from '../types/CandidateBoard';
type Props = {
  divideStatus: string;
  boardId?: number;
  title?: string;
  orderNumber?: number;
  colorType?: string;
  onClose?: () => void;
  onUpdateSuccess?: () => void;
};

export default function CandidatesSelectSortMenu({
  divideStatus,
  boardId,
  title = '',
  orderNumber = 0,
  colorType = 'gray',
  onClose,
  onUpdateSuccess,
}: Props) {
  const { data: boards } = useFetchCandidateBoards();
  const { mutateAsync: updateBoard } = useUpdateCandidateBoard();

  const usedDivideStatuses: string[] = boards?.records.map((board) => board.divide_status) || [];

  return (
    <div
      className="flex w-[150px] flex-col rounded-sm bg-white shadow-layer3"
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      role="menu"
    >
      {DIVIDE_STATUS_ITEMS.map((i, key) => {
        const isDisabled = i.value !== 'not_divided' && usedDivideStatuses.includes(i.value);

        return (
          <button
            type="button"
            className={clsx(
              'flex h-xxl items-center gap-xxs px-sm',
              isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:bg-gray_darken'
            )}
            key={key}
            disabled={isDisabled}
            onClick={async () => {
              if (boardId && i.value !== divideStatus) {
                try {
                  await updateBoard({
                    id: boardId,
                    title,
                    divide_status: i.value,
                    order_number: orderNumber,
                    color_type: colorType as Color,
                  });
                  if (onUpdateSuccess) {
                    onUpdateSuccess();
                  }
                } catch (error) {
                  console.error('Failed to update board:', error);
                }
              }
              if (onClose) {
                onClose();
              }
            }}
          >
            <p className="text-body-xs">{i.label}</p>
            {i.value === divideStatus && (
              <img
                src="/agent/candidates/icon-check-circle.svg"
                width={16}
                height={16}
                alt=""
                className="ml-auto"
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
